import { render, staticRenderFns } from "./SideNavbar.vue?vue&type=template&id=3ac2ac88&scoped=true&"
import script from "./SideNavbar.vue?vue&type=script&lang=js&"
export * from "./SideNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SideNavbar.vue?vue&type=style&index=0&id=3ac2ac88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac2ac88",
  null
  
)

export default component.exports